import classNames from 'classnames'
import {
  AnswerStatus,
  AnswerStatusIcon,
} from '../../../pages/GameEditor/components/EditorSidebar/Play/components/GradeAnswersPanel/components/AnswerStatusIcon'
import { PointsView } from '../../../pages/GameEditor/components/EditorSidebar/Play/components/GradeAnswersPanel/components/PointsView'
import { CheckboxSubtask } from '../../../types/commonTypes'
import { safeIsNullOrEmpty } from '../../../util/string'
import styles from './SubtaskPreview.module.css'

type CheckboxPreviewProps = {
  subtask: CheckboxSubtask
  noPointsGame?: boolean
  wide?: boolean
}

export const CheckboxPreview: React.FC<CheckboxPreviewProps> = ({ subtask, noPointsGame, wide }) => {
  return (
    <div
      className={classNames(
        styles.subtaskPreviewContainer,
        noPointsGame && styles.choiceOptionNoPointsPadding,
        wide && styles.subtaskPreviewContainerWide,
      )}
    >
      {subtask.data.answers?.map((answer, index) => {
        const isCorrect = noPointsGame ? answer.isCorrectAnswer : (answer.points ?? 0) > 0
        return (
          <div key={`${subtask.id}_cb_${index}`} className={styles.answerOptionRow}>
            <div
              className={classNames(
                styles.choiceAnswerOptionContainer,
                isCorrect && styles.choiceAnswerOptionContainer_correct,
              )}
            >
              <div className={styles.choiceAnswerOptionImageAndText}>
                {!safeIsNullOrEmpty(answer.imageUrl) && <img width={86} src={answer.imageUrl} alt='' />}
                <span>{answer.text}</span>
              </div>
              {isCorrect && <AnswerStatusIcon status={AnswerStatus.SUCCESS} />}
            </div>
            {!noPointsGame && !subtask.data.hasTotalPoints && (
              <div>
                <PointsView points={answer.points ?? 0} />
              </div>
            )}
          </div>
        )
      })}
    </div>
  )
}
